import { Link as RRLink, type LinkProps as RRLinkProps } from "@remix-run/react"
import type { InfluencerRoute } from "../influencer-routes.ts"

export const Link = (props: LinkProps) => {
  return <RRLink viewTransition {...props} />
}

interface LinkProps extends Omit<RRLinkProps, "to"> {
  to: InfluencerRoute
}
